// extracted by mini-css-extract-plugin
export default {"button":"NewModal_button__451XX","divider":"NewModal_divider__j9gXs","link":"NewModal_link__jEQI5"};